import {Question} from '../../../services/forms-v2-service';
import {BooleanQuestion} from './BooleanQuestion';
import {CheckboxQuestion} from './CheckboxQuestion';
import {NumberQuestion} from './NumberQuestion';
import {RadioButtonQuestion} from './RadioButtonQuestion';
import {SelectQuestion} from './SelectQuestion';
import {TextQuestion} from './TextQuestion';
import {TextareaQuestion} from './TextareaQuestion';
import {UnsupportedQuestion} from './UnsupportedQuestion';

interface FollowUpQuestionProps {
  question: Question;
}

export default function FollowUpQuestion(
  props: Readonly<FollowUpQuestionProps>,
) {
  const {question} = props;

  switch (question.dataType) {
    case 'text':
      return <TextQuestion question={question} />;
    case 'select-simple':
      return <RadioButtonQuestion question={question} />;
    case 'select-multiple':
      return <CheckboxQuestion question={question} />;
    case 'list':
      return <SelectQuestion question={question} />;
    case 'boolean':
      return <BooleanQuestion question={question} />;
    case 'numeric':
      return <NumberQuestion question={question} />;
    case 'textarea':
      return <TextareaQuestion question={question} />;
    default:
      return <UnsupportedQuestion question={question} />;
  }
}
